module.exports = __webpack_public_path__ + "static/Primary-Composite-5@2x-6efbc6073a29cabd0886e38e653a8eff.png";